// Handle post edit and delete actions using event delegation
// This ensures buttons work even after being restored from cancel

// Create message container for showing errors/success messages
function showMessage(message, isError = true) {
    // Remove any existing message
    const existingMessage = document.querySelector('.inline-edit-message');
    if (existingMessage) {
        existingMessage.remove();
    }

    // Create message element
    const messageDiv = document.createElement('div');
    messageDiv.className = `inline-edit-message ${isError ? 'error' : 'success'}`;
    messageDiv.innerHTML = `<p>${message}</p>`;

    // Insert at top of article content
    const article = document.querySelector('.article-content');
    if (article) {
        article.insertBefore(messageDiv, article.firstChild);

        // Scroll to message
        messageDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        // Auto-remove after 5 seconds
        setTimeout(() => {
            messageDiv.remove();
        }, 5000);
    }
}

// Delete post functionality using event delegation
document.addEventListener('click', async function(e) {
    const deleteButton = e.target.closest('.btn-delete-post');
    if (!deleteButton) return;

    e.preventDefault();
    const postId = deleteButton.getAttribute('data-post-id');

    if (!confirm('Er du sikker på at du vil slette dette innlegget?')) {
        return;
    }

    try {
        const data = new FormData();
        data.append('action', 'delete_post');
        data.append('post_id', postId);

        const response = await $.ajax({
            url: feltpost_scripts.ajax_url,
            type: 'POST',
            data: data,
            cache: false,
            processData: false,
            contentType: false
        });

        if (response.status === 'ok') {
            showMessage('Innlegget ble slettet!', false);
            // Redirect to homepage after short delay
            setTimeout(() => {
                window.location.href = '/';
            }, 1500);
        } else {
            showMessage('Kunne ikke slette innlegget');
        }
    } catch (error) {
        console.error('Delete error:', error);
        showMessage('Feil ved sletting. Vennligst prøv igjen.');
    }
});

// Edit post functionality - inline editing using event delegation
document.addEventListener('click', async function(e) {
    const editButton = e.target.closest('.btn-edit-post');
    if (!editButton) return;

    e.preventDefault();
    const postId = editButton.getAttribute('data-post-id');
    const article = document.querySelector('.article-content');

    if (!article) {
        showMessage('Kunne ikke finne innlegget');
        return;
    }

    // Check if already in edit mode
    if (article.classList.contains('editing')) {
        return;
    }

    try {
        const data = new FormData();
        data.append('action', 'get_post_for_edit');
        data.append('post_id', postId);

        let response;
        try {
            response = await $.ajax({
                url: feltpost_scripts.ajax_url,
                type: 'POST',
                data: data,
                cache: false,
                processData: false,
                contentType: false
            });
        } catch (xhr) {
            // Handle server error responses
            if (xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.message) {
                showMessage(xhr.responseJSON.data.message);
            } else {
                showMessage('Feil ved henting av innleggsdata. Vennligst prøv igjen.');
            }
            return;
        }

        if (response.success) {
            const postData = response.data;

            // Mark article as editing
            article.classList.add('editing');

            // Replace title with input
            const titleH1 = article.querySelector('.article-h1');
            const originalTitle = titleH1.innerHTML;
            titleH1.setAttribute('data-original', originalTitle);
            titleH1.innerHTML = `<input type="text" class="edit-title-input" value="${postData.title}" />`;

            // Replace content with textarea
            const articleBody = article.querySelector('.article-body');
            const originalContent = articleBody.innerHTML;
            articleBody.setAttribute('data-original', originalContent);

            // Strip HTML tags from content for editing
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = postData.content;
            const textContent = tempDiv.textContent || tempDiv.innerText || '';

            articleBody.innerHTML = `<textarea class="edit-content-textarea" rows="10">${textContent}</textarea>`;

            // Update post-actions buttons
            const postActions = article.querySelector('.post-actions');
            if (postActions) {
                const originalButtons = postActions.innerHTML;
                postActions.setAttribute('data-original', originalButtons);
                postActions.innerHTML = `
                    <button class="btn-cancel-edit">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L13 13M1 13L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        Avbryt
                    </button>
                    <button class="btn-save-edit" data-post-id="${postId}" data-post-type="${postData.post_type}">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 11.0833V14H2.91667L11.5583 5.35833L8.64167 2.44167L0 11.0833ZM13.7583 3.15833C14.0806 2.83611 14.0806 2.31389 13.7583 1.99167L12.0083 0.241667C11.6861 -0.0805556 11.1639 -0.0805556 10.8417 0.241667L9.49167 1.59167L12.4083 4.50833L13.7583 3.15833Z" fill="currentColor"/>
                        </svg>
                        Oppdater
                    </button>
                `;

                // Cancel button handler
                const cancelBtn = postActions.querySelector('.btn-cancel-edit');
                cancelBtn.addEventListener('click', function() {
                    // Restore original content
                    titleH1.innerHTML = titleH1.getAttribute('data-original');
                    articleBody.innerHTML = articleBody.getAttribute('data-original');
                    postActions.innerHTML = postActions.getAttribute('data-original');
                    article.classList.remove('editing');
                });

                // Save button handler
                const saveBtn = postActions.querySelector('.btn-save-edit');
                saveBtn.addEventListener('click', async function() {
                    const newTitle = article.querySelector('.edit-title-input').value.trim();
                    const newContent = article.querySelector('.edit-content-textarea').value.trim();

                    if (!newTitle) {
                        showMessage('Overskrift er påkrevd');
                        return;
                    }

                    if (!newContent) {
                        showMessage('Innhold er påkrevd');
                        return;
                    }

                    saveBtn.disabled = true;

                    try {
                        const updateData = new FormData();
                        updateData.append('action', 'add_editor_post');
                        updateData.append('post_id', postId);
                        updateData.append('title', newTitle);
                        updateData.append('content', newContent);
                        updateData.append('post_type', postData.post_type);

                        const updateResponse = await $.ajax({
                            url: feltpost_scripts.ajax_url,
                            type: 'POST',
                            data: updateData,
                            cache: false,
                            processData: false,
                            contentType: false
                        });

                        if (updateResponse.success) {
                            showMessage('Innlegget ble oppdatert!', false);
                            // Reload page after short delay to show updated content
                            setTimeout(() => {
                                window.location.reload();
                            }, 1500);
                        } else {
                            showMessage(updateResponse.data?.message || 'Feil ved oppdatering');
                            saveBtn.disabled = false;
                        }
                    } catch (error) {
                        console.error('Update error:', error);
                        showMessage('Feil ved oppdatering. Vennligst prøv igjen.');
                        saveBtn.disabled = false;
                    }
                });
            }

            // Focus title input
            const titleInput = article.querySelector('.edit-title-input');
            if (titleInput) {
                titleInput.focus();
                titleInput.select();
            }

        } else {
            showMessage(response.data?.message || 'Kunne ikke hente innleggsdata');
        }
    } catch (error) {
        console.error('Edit error:', error);
        showMessage('Feil ved henting av innleggsdata. Vennligst prøv igjen.');
    }
});
